<template>
    <div>
        <v-toolbar flat>
            <v-toolbar-title>
                MyPEEPS Admin
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text>
                    <v-icon left>mdi-account</v-icon>
                    {{ user.name || user.email }}
                </v-btn>
                <v-btn text @click="logout">
                    <v-icon left>mdi-logout</v-icon>
                    Logout
                </v-btn>
            </v-toolbar-items>
            <v-toolbar-items class="hidden-md-and-up">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list dense>
                        <v-list-item>
                            <v-list-item-action>
                                <v-btn text>
                                    <v-icon left>mdi-account</v-icon>
                                    {{ user.name || user.email }}
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-action>
                                <v-btn text @click="logout">
                                    <v-icon left>mdi-logout</v-icon>
                                    Logout
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <v-main>
            <v-container fluid>
                <keep-alive>
                    <Users :user="user"></Users>
                </keep-alive>
            </v-container>
        </v-main>
    </div>
</template>

<script>
    import api from '@/api';
    import router from '@/router';
    import Users from '@/components/admin/Users';
    import { includes } from 'lodash';

    export default {
        name: 'Admin',
        components: { Users },
        data() {
            return {
                user: {}
            };
        },
        computed: {},
        methods: {
            logout() {
                api.get('/logout').then(() => {
                    router.replace({ name: 'home' });
                });
            }
        },
        mounted() {},
        beforeDestroy() {},
        beforeRouteEnter(to, from, next) {
            api.get('/login')
                .then((response) => {
                    const user = response.data;
                    if (!includes(user.roles, 'admin')) {
                        return next({ name: 'home', replace: true });
                    }
                    next((vm) => {
                        vm.user = user;
                    });
                })
                .catch(() => {
                    next({ name: 'home', replace: true });
                });
        }
    };
</script>

<style scoped>
    ::v-deep .v-btn {
        text-transform: none;
    }
</style>
